// file src/constants/student.constants.ts
export const attendanceSessionConstants = {
    GETALL_REQUEST: 'ATTENDANCE_SESSION_GETALL_REQUEST',
    GETALL_SUCCESS: 'ATTENDANCE_SESSION_GETALL_SUCCESS',
    GETALL_FAILURE: 'ATTENDANCE_SESSION_GETALL_FAILURE',
  
    DELETE_REQUEST: 'ATTENDANCE_SESSION_DELETE_REQUEST',
    DELETE_SUCCESS: 'ATTENDANCE_SESSION_DELETE_SUCCESS',
    DELETE_FAILURE: 'ATTENDANCE_SESSION_DELETE_FAILURE',

    CREATE_REQUEST: 'ATTENDANCE_SESSION_CREATE_REQUEST',
    CREATE_SUCCESS: 'ATTENDANCE_SESSION_CREATE_SUCCESS',
    CREATE_FAILURE: 'ATTENDANCE_SESSION_CREATE_FAILURE',

    UPDATE_REQUEST: 'ATTENDANCE_SESSION_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'ATTENDANCE_SESSION_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'ATTENDANCE_SESSION_UPDATE_FAILURE',

    ADD_FROM_GG_SHEET_REQUEST: 'ADD_STUDENT_LIST_FROM_GG_SHEET_REQUEST',
    ADD_FROM_GG_SHEET_SUCCESS: 'ADD_STUDENT_LIST_FROM_GG_SHEET_SUCCESS',
    ADD_FROM_GG_SHEET_FAILURE: 'ADD_STUDENT_LIST_FROM_GG_SHEET_FAILURE',
};
